import React from "react"
import { Lead } from "rebass"

const Description = props => (
  <Lead
    {...props}
    mb={[3, 4, 5]}
    color="#4d4d4d"
    fontWeight={500}
    fontSize={[3, 4, 5]}
  />
)

export default Description



// WEBPACK FOOTER //
// ./src/containers/Hero/Description.js